import { render, staticRenderFns } from "./Cup.vue?vue&type=template&id=44fcd036&scoped=true"
import script from "./Cup.vue?vue&type=script&lang=js"
export * from "./Cup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44fcd036",
  null
  
)

export default component.exports